import React, { useEffect, useState } from 'react';
import MUIDataTable from "mui-datatables";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Constants
import { table_style } from "../../constants/MaterialTable";
// Assets
import "../../assets/css/tabelaListagem.css";
import { Tooltip } from 'reactstrap';

export default function TabelaListagem({ title = "", headers, items = [], actions = [], options = { print: false, search: false, pagination: true } }) {
    const [openTooltip, setOpenTooltip] = useState(null)
    // Inserindo a posição de cada item em cada linha da tabela para facilitar consultas
    useEffect(() => {
        items = items.map((value, index) => {
            value.tableData = {};
            value.tableData.id = index;
            return value;
        })
    }, [items]);

    return (
        <div className={`mb-4 w-100`}>
            <MUIDataTable
                style={{ minHeight: "auto" }}
                title={title}
                columns={[
                    ...actions.length > 0 ? [{
                        name: "AÇÕES",
                        options: {
                            filter: false,
                            sort: false,
                            empty: true,
                            customBodyRenderLite: (dataIndex) => {
                                return (
                                    <div className='d-flex flex-direction-row'>
                                        {
                                            actions.map((value, index) => {
                                                if (typeof value === 'function') {
                                                    const functionValue = value(items[dataIndex]);
                                                    if (functionValue != null) {
                                                        const tooltipId = `tooltip-${dataIndex}-${index}`;
                                                        return (
                                                            <div key={index} className="d-inline-block">
                                                                <button
                                                                    id={tooltipId}
                                                                    className={`tableOption me-3 ${functionValue.color}`}
                                                                    onClick={(e) => {
                                                                        functionValue.onClick(e, items[dataIndex]);
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon icon={functionValue.icon} />
                                                                </button>
                                                                <Tooltip
                                                                    placement="top"
                                                                    isOpen={openTooltip === tooltipId}
                                                                    target={tooltipId}
                                                                    toggle={() =>
                                                                        setOpenTooltip(openTooltip === tooltipId ? null : tooltipId)
                                                                    }
                                                                    className="custom-tooltip"
                                                                >
                                                                    {functionValue.tooltip}
                                                                </Tooltip>
                                                            </div>
                                                        );
                                                    }
                                                } else {
                                                    return (
                                                        <button key={index} className={`me-3 tableOption ${value.color}`} onClick={(e) => {
                                                            value.onClick(e, items[dataIndex]);
                                                        }}>
                                                            <FontAwesomeIcon icon={value.icon} />
                                                        </button>
                                                    );
                                                }
                                            })
                                        }
                                    </div>
                                );
                            }
                        }
                    }] : [],
                    ...headers.map(value => {
                        return {
                            label: value.value,
                            name: value.objectValue,
                            setCellHeaderProps: () => ({
                                align: value.align ? value.align : "center",
                            }),
                            setCellProps: () => ({
                                align: value.align ? value.align : "center",
                            }),
                            options: value.options ? {
                                ...value.options,
                            } : { filter: false }
                        }
                    })
                ]}
                options={{
                    ...options,
                    filter: headers.length > 0 ? headers.some(header => header.options?.filter === true) : false,
                    download: false,
                    selectableRows: "none",
                    ...table_style,
                    pageSize: 10,
                    responsive: "standard"
                }}
                data={items}
            />
        </div>
    )
}
